import React from 'react'
import { FaFacebookF, FaInstagram } from 'react-icons/fa'
import Button from './Button'
import { useNavigate } from "react-router-dom";


function Footer() {
  const navigate = useNavigate();
  
  return (
    <div className="footer">
      <div style={{display: 'flex', gap: '12px', alignItems: 'center'}}>
        <a href="https://web.facebook.com/profile.php?id=100054504637700" target="_blank" rel="noreferrer" style={{color: 'white', backgroundColor: '#1877F2', padding: '8px', borderRadius: '8px'}}>
          <FaFacebookF size="24px" />
        </a>
        <a href="https://www.instagram.com/decor.delights.and.events/" target="_blank" rel="noreferrer" style={{color: 'white', backgroundColor: '#E4405F', padding: '8px', borderRadius: '8px'}}>
          <FaInstagram size="24px" />
        </a>
      </div>
      <div className='footer-separator'></div>
      <div>
        <p>Tel: +1 423-430-5282</p>
        <p>Email: decordelights365@gmail.com</p>
      </div>
      <div className='footer-separator'></div>
      <div className='credit'>
        <p>© 2026 by Decor Delights and Events.</p>
        <p>Developed and secured by majorleaguedevelopers@gmail.com</p>
      </div>
      <Button name="Contact Us" action={() => navigate("/contact")} />
    </div>
  )
}

export default Footer